import React from 'react';
import {} from 'semantic-ui-react';

import PagoCheque from './PagoCheque';
import PagoDeposito from './PagoDeposito';
import PagoEfectivo from './PagoEfectivo';
import PagoTarjeta from './PagoTarjeta';
import PagoTransferencia from './PagoTransferencia';
import { MetodosDePago } from './tipos';

interface PagoProps {
    nombreCompletoApoderado: string;
    rutPasaporteApoderado: string;

    metodoDePago: MetodosDePago;
    numeroDeCheque: string;
    idInstitucionCheque: string;
    numeroDeCuentaCheque: string;
    nombreTitularCheque: string;
    rutTitularCheque: string;
    fechaCheque: string;
    esDeTercerosCheque: boolean;

    tipoDeTarjeta: 'debito' | 'credito';
    tipoDeTarjetaDeCredito: 'visa' | 'mastercard' | 'americanexpress';
    numeroDeCuotasCredito?: number;
    idInstitucionTarjeta?: string;

    numeroDeDeposito: string;

    tipoDeCuenta: '' | 'corriente' | 'vista' | 'chequera';
    idInstitucionTransferencia: string;
    numeroDeCuentaTransferencia: string;
    nombreDelTitularTransferencia: string;
    esDeTercerosTransferencia: boolean;
    rutTitularTransferencia: string;

    alCambiarCampo(nombreDelCampo: string, valor: string | boolean | number): void;
}

const Pago: React.FunctionComponent<PagoProps> = props => {
    const {
        metodoDePago,
        alCambiarCampo,

        nombreCompletoApoderado,
        rutPasaporteApoderado,

        numeroDeCheque,
        idInstitucionCheque,
        numeroDeCuentaCheque,
        nombreTitularCheque,
        rutTitularCheque,
        fechaCheque,
        esDeTercerosCheque,

        tipoDeTarjeta,
        tipoDeTarjetaDeCredito,
        numeroDeCuotasCredito,
        idInstitucionTarjeta,

        numeroDeDeposito,

        tipoDeCuenta,
        idInstitucionTransferencia,
        numeroDeCuentaTransferencia,
        nombreDelTitularTransferencia,
        esDeTercerosTransferencia,
        rutTitularTransferencia,
    } = props;
    switch (metodoDePago) {
        case 'efectivo':
            return (
                <div>
                    <PagoEfectivo />
                </div>
            );
        case 'tarjeta':
            return (
                <div>
                    <PagoTarjeta
                        tipoDeTarjeta={tipoDeTarjeta}
                        tipoDeTarjetaDeCredito={tipoDeTarjetaDeCredito}
                        numeroDeCuotasCredito={numeroDeCuotasCredito}
                        idInstitucionTarjeta={idInstitucionTarjeta}
                        alCambiarCampo={alCambiarCampo}
                    />
                </div>
            );
        case 'cheque':
            return (
                <div>
                    <PagoCheque
                        numeroDeCheque={numeroDeCheque}
                        idInstitucionCheque={idInstitucionCheque}
                        numeroDeCuentaCheque={numeroDeCuentaCheque}
                        nombreTitularCheque={nombreTitularCheque}
                        rutTitularCheque={rutTitularCheque}
                        fechaCheque={fechaCheque}
                        esDeTercerosCheque={esDeTercerosCheque}
                        alCambiarCampo={alCambiarCampo}
                        nombreCompletoApoderado={nombreCompletoApoderado}
                        rutPasaporteApoderado={rutPasaporteApoderado}
                    />
                </div>
            );
        case 'deposito':
            return (
                <div>
                    <PagoDeposito
                        numeroDeDeposito={numeroDeDeposito}
                        alCambiarCampo={alCambiarCampo}
                    />
                </div>
            );
        case 'transferencia':
            return (
                <div>
                    <PagoTransferencia
                        tipoDeCuenta={tipoDeCuenta}
                        idInstitucionTransferencia={idInstitucionTransferencia}
                        numeroDeCuentaTransferencia={numeroDeCuentaTransferencia}
                        nombreDelTitularTransferencia={nombreDelTitularTransferencia}
                        esDeTercerosTransferencia={esDeTercerosTransferencia}
                        rutTitularTransferencia={rutTitularTransferencia}
                        alCambiarCampo={alCambiarCampo}
                    />
                </div>
            );
        default:
            return null;
    }
};

export default Pago;



// WEBPACK FOOTER //
// ./src/modulos/Cobranzas/componentes/FichaDeApoderado/Pago.tsx